<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !radioStatus}"
          @click="radioStatus =! radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioValue.value"
          @change="changeOption"
        >
          {{ radioValue.label }}
        </el-radio>
      </div>
      <el-checkbox
        v-model="radioStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { showPrefetch, loadPrefetchToPage } from '@/utils/prefetch'

export default {
  name: 'RadioPrefetch',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: [Boolean, String]
    },
    hint: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      value: this.default,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false
    }
  },
  computed: {
    ...mapState([
      'clearOptions',
      'zoomEnable'
    ]),
    showPrefetch(){
      return showPrefetch.value
    }
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.radioStatus = false
        this.value = this.default
      }
    },
    eventClick(val) {
      this.value = this.default
      this.radioStatus = val
    },
    radioStatus(val) {
        this.changeOption()
    },
  },
  methods: {
    changeOption () {
      showPrefetch.value = this.radioStatus ? this.value : false 
      loadPrefetchToPage()
    }
  }
}
</script>
